(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-item"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFeaturedSection(sectionId) {
    var track = document.getElementById('ctnFeaturedTrack-' + sectionId);
    var dotsContainer = document.getElementById('ctnFeaturedDots-' + sectionId);
    if (!track) return;

    var cards = track.querySelectorAll('.ctn-featured__card');
    var dots = dotsContainer ? dotsContainer.querySelectorAll('.ctn-featured__dot') : [];

    // カード出現アニメーション
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = parseInt(entry.target.dataset.index || 0) * 60;
          setTimeout(function () { entry.target.classList.add('is-visible'); }, delay);
        }
      });
    }, { threshold: 0.1 });
    cards.forEach(function (card) { observer.observe(card); });

    if (!dotsContainer || dots.length === 0) return;

    // 前後ボタン
    var prevBtn = document.getElementById('ctnFeaturedPrev-' + sectionId);
    var nextBtn = document.getElementById('ctnFeaturedNext-' + sectionId);

    function getCurrentIndex() {
      return Math.round(track.scrollLeft / track.offsetWidth);
    }

    function updateUI(idx) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === idx);
      });
      if (prevBtn) prevBtn.disabled = idx <= 0;
      if (nextBtn) nextBtn.disabled = idx >= cards.length - 1;
    }

    updateUI(0);

    // スクロール → ドット＆ボタン同期
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          updateUI(getCurrentIndex());
          ticking = false;
        });
        ticking = true;
      }
    });

    // ドットクリック → スクロール
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        track.scrollTo({
          left: parseInt(dot.dataset.index || 0) * track.offsetWidth,
          behavior: 'smooth'
        });
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollTo({ left: Math.max(0, getCurrentIndex() - 1) * track.offsetWidth, behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollTo({ left: Math.min(cards.length - 1, getCurrentIndex() + 1) * track.offsetWidth, behavior: 'smooth' });
      });
    }
  }

  // テーマエディタ内リロード対応
  document.addEventListener('shopify:section:load', function (e) {
    initFeaturedSection(e.detail.sectionId);
  });

  // 通常ロード
  document.querySelectorAll('[data-section-type="cetten-featured-item"]').forEach(function (el) {
    initFeaturedSection(el.dataset.sectionId);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
